import { z } from "zod";

export interface IReportChapterNode {
  id: string;
  title: string;
  isActive: boolean;
  text?: string;
  children?: IReportChapterNode[];
  isDisabled?: boolean;
}

export const ZReportChapterNodeSchema: z.ZodType<IReportChapterNode> = z.lazy(() =>
  z.object({
    id: z.string().min(1),
    title: z.string().min(1),
    isActive: z.boolean(),
    text: z.string().optional(),
    children: z.array(ZReportChapterNodeSchema).optional(),
    isDisabled: z.boolean().optional(),
  }),
);

export const ZReportChaptersSchema = z.array(ZReportChapterNodeSchema);

export type IReportChapters = IReportChapterNode[];
